import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import Alert from '@material-ui/lab/Alert'

const CustomSnackbar = ({ isOpen, handleClose, content, severity, duration = 1000 }) => 
(<Snackbar open={isOpen} autoHideDuration={duration}>
  <Alert elevation={6} onClose={handleClose} variant="filled" severity={severity} >{content}</Alert>
</Snackbar>)

export default CustomSnackbar